import { useCallback, useEffect, useRef, useState } from 'react';
import { parseSkillsSnapshot } from './desktopSkills.js';
export function useDesktopSkills(enabled) {
    const [snapshot, setSnapshot] = useState(null);
    const [state, setState] = useState('loading');
    const [refreshing, setRefreshing] = useState(false);
    const [error, setError] = useState(null);
    const timeout = useRef(undefined);
    const latest = useRef(0);
    const available = useRef(false);
    const refresh = useCallback(() => {
        if (!enabled)
            return;
        setRefreshing(true);
        setError(null);
        clearTimeout(timeout.current);
        // Arm before dispatch: the host can synchronously replay a completed snapshot.
        timeout.current = setTimeout(() => {
            setRefreshing(false);
            setError('Skill discovery did not finish. Try scanning again.');
        }, 20_000);
        window.dispatchEvent(new CustomEvent('gyro:skills-refresh'));
    }, [enabled]);
    useEffect(() => {
        if (!enabled)
            return;
        latest.current = 0;
        available.current = false;
        setSnapshot(null);
        setState('loading');
        setRefreshing(false);
        setError(null);
        const initial = setTimeout(() => {
            setState(current => current === 'ready' ? current : 'unavailable');
            if (available.current)
                setError('Skill discovery did not finish. Try scanning again.');
        }, 20_000);
        const announce = () => { available.current = true; };
        const receive = (event) => {
            const next = parseSkillsSnapshot(event.detail);
            if (!next || next.updatedAt < latest.current)
                return;
            latest.current = next.updatedAt;
            available.current = true;
            setSnapshot(next);
            if (next.discoveryState === 'loading')
                return;
            clearTimeout(initial);
            clearTimeout(timeout.current);
            setState('ready');
            setRefreshing(false);
            setError(null);
        };
        window.addEventListener('gyro:skills-available', announce);
        window.addEventListener('gyro:skills-snapshot', receive);
        window.dispatchEvent(new CustomEvent('gyro:skills-ready'));
        return () => {
            window.removeEventListener('gyro:skills-available', announce);
            window.removeEventListener('gyro:skills-snapshot', receive);
            clearTimeout(initial);
            clearTimeout(timeout.current);
        };
    }, [enabled]);
    return enabled ? { snapshot, state, refreshing, error, refresh } : { snapshot: null, state: 'unavailable', refreshing: false, error: null, refresh };
}
//# sourceMappingURL=useDesktopSkills.js.map